import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

import LocalStorage from "services/LocalStorage";
import useBoundStore from "store";
import { AppColor } from "store/generalSettingsSlice";

interface EditAppColorDialogProps {
  open: boolean;
  onClose: () => void;
}

function EditAppColorDialog(props: EditAppColorDialogProps) {
  const { open, onClose } = props;
  const primaryColor = useBoundStore((state) => state.generalSettings.primaryColor);
  const setGeneralSettings = useBoundStore((state) => state.generalSettings.set);
  const localStorage = LocalStorage.getInstance();

  const handleSelectAppColor = (e: React.ChangeEvent<HTMLInputElement>) => {
    const colorValue = e.target.value as AppColor;

    localStorage.setPrimaryColor(colorValue);
    setGeneralSettings({ primaryColor: colorValue });
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby='app-color-dialog' maxWidth='xs' fullWidth>
      <DialogTitle id='app-color-dialog'>Choose app color</DialogTitle>
      <DialogContent>
        <FormControl component='fieldset'>
          <RadioGroup aria-label='App color' name='appColor' value={primaryColor} onChange={handleSelectAppColor}>
            <FormControlLabel value='teal' control={<Radio />} label='Teal' />
            <FormControlLabel value='pink' control={<Radio />} label='Pink' />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditAppColorDialog;
